import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig, DialogPosition } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TicketsService } from 'src/app/service/ticket/tickets.service';
import { merge, Observable, of as observableOf, Subscription } from 'rxjs';
import { startWith, switchMap, catchError, map } from 'rxjs/operators';
import { ITicket } from 'src/app/models/ticket.interface';
import { DetailComponent } from './detail/detail.component';
import { strict } from 'assert';
import { FormControl } from '@angular/forms';
import {DatePipe, formatDate} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import { selectSession } from '../store/selectors/page.selectors';
import { IAppState } from '../store/state/app.state';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../date.adapter';
import {IIdentify} from '../models/identify.interface';
import {selectIdentify} from '../store/selectors/identify.selectors';
import {environment} from '../../environments/environment';
import {PostmessageService} from '../service/utility/sendmessage/postmessage.service';

enum BetType {
  'QF' = 4,
}

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    }
  ],
})
export class TicketsComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  public identify$: Observable<IIdentify>;
  public innerHeight: any;

  displayedColumns: string[] = [
    'data_ora_vendita',
    'puntata',
    'pagamento_reale',
    'pagamento_massimo',
    'id_biglietto',
  ];

  data: ITicket[] = [];

  betType: typeof BetType = BetType;

  status = '-1';

  private session = '';

  token = '';

  dateMax = new Date();
  dateMin = new Date();
  dateFrom = new FormControl(new Date());
  dateTo = new FormControl(new Date());

  dataSource: MatTableDataSource<ITicket>;

  resultsLength = 0;
  public isLoadingResults = false;
  isRateLimitReached = false;
  serviceError = {
    description: '',
    ret_code: ''
  };

  environment = environment;

  statuses: any[] = [
    { value: '-1', viewValue: 'All' },
    { value: '0', viewValue: 'Loser' },
    { value: '1', viewValue: 'Winner' },
    { value: '2', viewValue: 'Open' },
    { value: '3', viewValue: 'Refundable' },
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  sessionObs$ = this._store.pipe(select(selectSession));

  constructor(
    public ticketsService: TicketsService,
    private dialogWindow: MatDialog,
    private datePipe: DatePipe,
    public translateService: TranslateService,
    private _store: Store<IAppState>,
    private dateAdapter: DateAdapter<Date>,
    private postmessage: PostmessageService
  ) {
    this.identify$ = this._store.pipe(select(selectIdentify));
    this.identify$.subscribe((ident) => {
      if (ident) {
        this.token = ident.token;
      }
    });
  }

  isLoading(): boolean {
    return this.isLoadingResults;
  }

  ngOnInit() {
    // this.dataSource = new MatTableDataSource([]);
    // If the user changes the sort order, reset back to the first page.
    // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // merge(this.sort.sortChange, this.paginator.page)
    //   .pipe(
    //     startWith({}),
    //     switchMap(() => {
    //       this.isLoadingResults = true;
    //       return this.ticketsService.getTickets();
    //     }),
    //     map(data => {
    //       // Flip flag to show that loading has finished.
    //       this.isLoadingResults = false;
    //       this.isRateLimitReached = false;
    //       this.resultsLength = data.biglietto.length;

    //       return data.biglietto;
    //     }),
    //     catchError(() => {
    //       this.isLoadingResults = false;
    //       // Catch if the GitHub API has reached its rate limit. Return empty data.
    //       this.isRateLimitReached = true;
    //       return observableOf([]);
    //     })
    //   ).subscribe(data => this.data = data);
    this.dateFrom.value.setDate(this.dateTo.value.getDate() - 10);
    this.dateMin.setDate(this.dateTo.value.getDate() - 90);

    this.subscription = this.sessionObs$.subscribe((x) => {
      this.session = x;
      this.retriveData();
    });

    this.innerHeight = window.innerHeight;

    this.setlangDatePicker();

  }

  setlangDatePicker() {
    if (this.translateService.currentLang === undefined) {
      setTimeout(() => {
        this.setlangDatePicker();
      }, 10);
    } else {
      this.dateAdapter.setLocale(this.translateService.currentLang);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  myFilter = (d: Date): boolean => {
    // Prevent Saturday and Sunday from being selected.
    return d > this.dateMin;
  }

  filterFromTo = (d: Date): boolean => {
    return d >= this.dateFrom.value;
  }

  retriveData() {
    if (!this.dateTo.value || !this.dateFrom.value || this.dateTo.value < this.dateFrom.value) {
      this.dataSource = new MatTableDataSource([]);
      this.isRateLimitReached = true;
      return false;
    }

    this.isLoadingResults = true;

    const dateFromString = this.datePipe.transform(this.dateFrom.value, 'yyyy-MM-dd');
    const dateToString = this.datePipe.transform(this.dateTo.value, 'yyyy-MM-dd');

    this.ticketsService
      .getTickets(dateFromString, dateToString, this.status, this.session)
      .pipe(
        map((data) => {
          this.serviceError = null;
          this.isLoadingResults = false;
          this.isRateLimitReached = false;

          if (data.error) {
            this.isRateLimitReached = true;
            this.serviceError = data.error;
            return [];
          }
          this.resultsLength = data.biglietto.length;
          return data.biglietto;
        }),
        catchError((err) => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          this.serviceError.description = 'TICKETS.NOTRECOVERED';
          this.serviceError.ret_code = 2000 + err.status;
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        data.forEach((x) => {
          // eslint-disable-next-line @typescript-eslint/camelcase
          x.data_ora_vendita = formatDate(x.data_ora_vendita, 'yyyy-MM-dd HH:mm:ss', this.translateService.currentLang).toString();
          x.data_ora_vendita = new Date(x.data_ora_vendita.replace(/-/g, "/"));
          // console.log(x.data_ora_vendita.toString());
        }, this);
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  showDetail(idBiglietto: string, statoSpoglio: string, event: MouseEvent, session?: string) {
    const dialogPosition: DialogPosition = {
      // top: (this.innerHeight - 500) / 2 + 'px'
      top: (window.innerWidth > 1199) ? event.clientY - 100 + 'px' : null,
    };
    this.isLoadingResults = true;
    this.ticketsService.ticketSelected = idBiglietto;

    this.ticketsService.sesssionSelected = this.session;
    if (!this.session && session) {
      this.ticketsService.sesssionSelected = session;
    }

    let classe: string;
    switch (statoSpoglio) {
      case '0': {
        classe = 'bd-callout-danger';
        break;
      }
      case '1': {
        classe = 'bd-callout-success';
        break;
      }
      case '2': {
        classe = 'bd-callout-info';
        break;
      }
      case '3': {
        classe = 'bd-callout-warning';
        break;
      }
      default: {
        classe = 'bd-callout-dark';
        break;
      }
    }

    this.ticketsService.retriveDetail().subscribe((detail) => {
      this.isLoadingResults = false;
      detail.cID = this.token;
      detail.modal = true;
      const config: MatDialogConfig = {
        // panelClass: ['bd-callout', classe],
        panelClass: [classe, 'dialog-tickets'],
        data: detail,
        position: dialogPosition,
        // maxHeight: '95vh',
        width: '480px',
        maxWidth: '95vw',
        autoFocus: false,
      };
      this.dialogWindow.open(DetailComponent, config);
      this.postmessage.sendPostMessage({
        func: 'scrollTopHandToHAnd',
        param: {
          top: event.clientY - 100,
        }
      });
      // window.parent.postMessage(
      //     {
      //       func: 'scrollTopHandToHAnd',
      //       param: {
      //         top: event.clientY - 100,
      //       }
      //     },
      //     '*'
      // );
    });
  }

  partnerIdentify(token): any {
    if (environment.sksCID.includes(token)) {
      return 'sks-content';
    }
  }
}
